(function (app, ng) {

    app.config([
        '$stateProvider', function ($stateProvider) {
            $stateProvider
                .state('Home.Tools.MarketingTrackerNew.DataInput.SpendingDataInput',
                    {
                        url: '/Spending',
                        component: 'spendingDataInputComponent',
                        PageTitle: 'Spending Data Input | Marketing Tracker',
                    });
        }
    ]);

    app.component('spendingDataInputComponent',
        {
            templateUrl: 'App/Tools/MarketingTrackerNew/MainDataInput/SpendingDataInput/spending-data-input.template.html',
            controller: spendingDataInputController,
            bindings: {
                today: '<',
                sources: '<',
                advisors: '<',
                statuses: '<',
                dateSelect: '<',
                selectedDate: '<',
            }
        });

    spendingDataInputController.$inject = ['marketingTrackerSalesTrackerInputApi', '_', '$filter', 'figToaster', '$timeout', "$state"];

    function spendingDataInputController(marketingTrackerSalesTrackerInputApi, _, $filter, figToaster, $timeout, $state) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                disableRow: false,
                loadingRows: false,
                columnName: 'Date',
                filterString: '',
                reverseOrder: true,
                table: {
                    header: [
                        {
                            name: 'Date',
                            displayName: 'Date',
                            required: true
                        },
                        {
                            name: 'Source.SourceName',
                            displayName: 'Source',
                            required: true
                        },
                        {
                            name: 'Amount',
                            displayName: 'Amount',
                            required: false
                        },
                        {
                            name: 'Notes',
                            displayName: 'Notes',
                            required: false
                        },
                    ],
                    body: []
                },
                model: {
                    Date: $ctrl.today,
                    Source: '',
                    Amount: 0,
                    Notes: '',
                },
                Indices: resetIndices(),
            });

        function resetIndices() {
            return {
                StartIndex: 0,
                IndexIncrement: 25,
                EndIndex: 0,
                Limit: 50
            };
        }

        $ctrl.increaseLimit = function () {
            $ctrl.Indices.Limit += $ctrl.Indices.IndexIncrement;
        };

        var message, toastClass = '';

        function resetFormModel() {
            $ctrl.form.$setPristine();
            $ctrl.form.$setUntouched();
            $ctrl.model = {
                Date: $ctrl.today.toLocaleDateString(),
                Source: '',
                Amount: 0,
                Notes: '',
            }
        }

        // make copy to compare changes on auto-save
        function copyTable() {
            $ctrl.table.bodyDupe = ng.copy($ctrl.table.body);
        }

        function getRowsByDateRange(selectedDate, enableLoading) {
            $ctrl.loadingRows = enableLoading === 'false' ? false : true;
            var startDate, endDate = null;
            startDate = selectedDate.value.startDate;
            endDate = selectedDate.value.endDate;

            return marketingTrackerSalesTrackerInputApi.getSpendingsByDate(startDate, endDate)
                .then(function (response) {
                    $ctrl.table.body = response;
                    copyTable();
                    $ctrl.loadingRows = false;
                });
        }

        function deleteRow(model) {
            return marketingTrackerSalesTrackerInputApi.deleteSpending(model.Id)
                .then(function () {
                    message = 'Row deleted';
                    toastClass = 'is-success';
                    $ctrl.table.body = _.without($ctrl.table.body, model);
                    copyTable();
                })
                .catch(function () {
                    message = 'Sorry, an error has occurred. Please try again later.';
                    toastClass = 'is-error';
                })
                .finally(function () {
                    return figToaster.showSimple(message, "top", toastClass);
                });
        }

        $ctrl.orderRows = function (columnName) {
            if (columnName) {
                $ctrl.reverseOrder = (columnName === $ctrl.columnName) ? !$ctrl.reverseOrder : false;
                $ctrl.columnName = columnName;
            } else {
                columnName = $ctrl.columnName;
            }
            $ctrl.table.body = $filter('orderBy')($ctrl.table.body, columnName, $ctrl.reverseOrder);
            copyTable();
        };

        $ctrl.filterByDate = function (selectedDateRange) {
            getRowsByDateRange(selectedDateRange)
                .then(function () {
                    $ctrl.orderRows(false);
                });
        };

        $ctrl.addRow = function (model) {
            if ($ctrl.form.$invalid) throw Error('Invalid field');

            $ctrl.disableRow = true;
            return marketingTrackerSalesTrackerInputApi.createSpending(model)
                .then(function (response) {
                    message = 'New row added';
                    toastClass = 'is-success';
                    $ctrl.addingRow = false;
                    resetFormModel();
                    $ctrl.table.body.unshift(response);
                    copyTable();
                })
                .catch(function () {
                    message = 'Sorry, an error has occurred. Please try again later';
                    toastClass = 'is-error';
                })
                .finally(function () {
                    $ctrl.disableRow = false;
                    return figToaster.showSimple(message, "top", toastClass);
                });
        };

        $ctrl.toggleEditRow = function (row, index) {
            row.edit = !row.edit;
            $ctrl.table.bodyDupe[index].edit = row.edit;
        };

        $ctrl.updateRow = function (row, form, index, logData) {
            // TODO: Figure out why air-datepicker input on template always trigger a form submission per instance whenever row.edit === true. Uncomment console logs below to see
            // console.log(row, $ctrl.table.bodyDupe[index]);
            // console.log(ng.equals(row, $ctrl.table.bodyDupe[index]));
            // if (logData) console.log(logData);
            
            if (form.$invalid) return;
            if (ng.equals(row, $ctrl.table.bodyDupe[index])) return;
            else {
                row.Amount = !!row.Amount ? row.Amount : '0.00';
                return marketingTrackerSalesTrackerInputApi.updateSpending(row)
                    .then(function () {
                        copyTable();
                    })
                    .catch(function () {
                        message = 'Sorry, an error has occurred. Please try again later.';
                        toastClass = 'is-error';
                        getRowsByDateRange($ctrl.selectedDate, 'false');
                        return figToaster.showSimple(message, "top", toastClass);
                    });
            }
        };

        $ctrl.deleteWithUndo = function (model, index) {
            model.showUndo = true;
            model.deferDelete = $timeout(function () {
                deleteRow(model, index);
            }, 1800);
        };

        $ctrl.undoDeleteRow = function (model) {
            $timeout.cancel(model.deferDelete);
            model.showUndo = false;
        };

        $ctrl.deleteRow = function (model) {
            return marketingTrackerSalesTrackerInputApi.deleteSpending(model.Id)
                .then(function () {
                    message = 'Row deleted';
                    toastClass = 'is-success';
                    $ctrl.table.body = _.without($ctrl.table.body, model);
                    copyTable();
                })
                .catch(function () {
                    message = 'Sorry, an error has occurred. Please try again later.';
                    toastClass = 'is-error';
                })
                .finally(function () {
                    return figToaster.showSimple(message, "top", toastClass);
                });
        };


        //TODO: finish this with autocomplete in UI : good reference: https://figdevteam.visualstudio.com/_git/AdvisorCRMCore?path=%2FAdvisorCRM%2FAdvisorCRM.Web.UI%2Fwwwroot%2FApp%2FMarketing%2FPipeline%2Fpipeline.html
        $ctrl.searchNotes = function (q) {
            return marketingTrackerSalesTrackerInputApi.getPreviousSpendingNotes(q).then(function (notes) {
                return notes;
            }, function () {
                return null;
            });
        };

        $ctrl.goToEvent = function(ancillaryEventGroupId, eventGroupId) {
            if (ancillaryEventGroupId)
            {
                return $state.go("Home.Tools.MarketingTrackerNew.Events.AncillaryEvent", { "EventGroupId": ancillaryEventGroupId, "EventId": 1 });
            }
            else
            {
                return $state.go("Home.Tools.MarketingTrackerNew.Events.EventView", { "EventGroupId": eventGroupId, "EventId": 1 });
            }
        }

        $ctrl.$onInit = function () {
            getRowsByDateRange($ctrl.selectedDate).then(function () {
                $ctrl.orderRows(false);
            });
        };

        $ctrl.export = function (selectedDate) {
            var startDate, endDate = null;
            startDate = selectedDate.value.startDate;
            endDate = selectedDate.value.endDate;
            marketingTrackerSalesTrackerInputApi.postExportSpendings(startDate, endDate).then(function (data) {
                var objectUrl = URL.createObjectURL(data);
                var a = document.createElement("a");
                a.style = "display:none";
                a.href = objectUrl;
                a.download = "Spending.xlsx";
                a.click();
            });
        };
    }

})(window.app, window.angular); //jshint ignore:line